import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useReportsStore = defineStore('reports', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getReports: (state) => state.data?.data,
  },
  actions: {
    async indexReports(params = {}) {
      try {
        const response = await axios.get('reports', {params} );
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createReport(params = {}) {
      try {
        const response = await axios.get('reports/create', {params} );
        return useCreateForm('reports', response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showReport( reportId, params = {}) {
      try {
        const response = await axios.get(`reports/${reportId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editReport( reportId, params = {}) {
      try {
        const response = await axios.get(`reports/${reportId}/edit`, {params} );
        return useEditForm(`reports/${reportId}`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteReport( reportId, params = {}) {
      try {
        const response = await axios.delete(`reports/${reportId}`, {params} );
        toasteventbus.emit('add', {
          summary: 'Report Deleted',
          detail: `Report has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
